export default __webpack_public_path__ + "img/bGSGxPBQ.b4f69c73.svg";